export default function NotificationLoading() {
  return (
    <div className='tw-flex tw-gap-2 tw-p-3'>
      <div className='tw-w-9 tw-h-9 tw-rounded-full tw-animate-skeleton-shimmer' />
      <div className='tw-flex tw-flex-col tw-gap-2 tw-grow'>
        <div className='tw-h-9 tw-flex tw-items-center tw-mb-2'>
          <div className='tw-grow tw-h-6 tw-animate-skeleton-shimmer' />
        </div>
        <div className='tw-grow tw-h-6 tw-animate-skeleton-shimmer' />
        <div className='tw-grow tw-h-6 tw-animate-skeleton-shimmer' />
      </div>
    </div>
  )
}
